import React from "react";
import { IoMail } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { commenIcon } from "../../data/CommenIcon.jsx";
import CopyRights from "./CopyRights.jsx";
import { Link } from "react-router-dom";
import { APP_CONFIG } from "../../config/app.config.js";

const Footer = () => {
  const footerMenu = [
    {
      id: 1,
      title: "Quick Menu",
      list: [
        { listTitle: "Home", path: "/" },
        { listTitle: "About", path: "/about" },
        { listTitle: "Services", path: "/service" },
        { listTitle: "Contact", path: "/contact" },
        { listTitle: "Blog", path: "/blog" },
        { listTitle: "FAQ", path: "/faq" },
      ],
    },
    {
      id: 2,
      title: "Services",
      list: [
        { listTitle: "Tax Consulting", path: "/servicedetails/1" },
        { listTitle: "Bookkeeping", path: "/servicedetails/2" },
        { listTitle: "Taxes", path: "/servicedetails/3" },
        { listTitle: "Business", path: "/servicedetails/4" },
        { listTitle: "Loans & Mortgages", path: "/servicedetails/5" },
        { listTitle: "Rental Property", path: "/servicedetails/6" },
        { listTitle: "Auditing", path: "/servicedetails/7" },
        { listTitle: "Payroll", path: "/servicedetails/8" },
        { listTitle: "Planning", path: "/servicedetails/9" },
        { listTitle: "Legally Required", path: "/servicedetails/10" },
      ],
    },
    {
      id: 3,
      title: "Quik Links",
      list: [
        { listTitle: "Employment Insurance (EI)", path: "https://www.canada.ca/en/services/benefits/ei.html", type: "_blank" },
        { listTitle: "Personal Taxes", path: "https://www.canada.ca/en/services/taxes/income-tax/personal-income-tax.html", type: "_blank" },
        { listTitle: "HST Credit", path: "https://www.canada.ca/en/revenue-agency/services/child-family-benefits/goods-services-tax-harmonized-sales-tax-gst-hst-credit.html", type: "_blank" },
        { listTitle: "Canada Child Benefit", path: "https://www.canada.ca/en/revenue-agency/services/child-family-benefits/canada-child-benefit-overview.html", type: "_blank" },
        { listTitle: "Old Age Security (OAS)", path: "https://www.canada.ca/en/services/benefits/publicpensions/cpp/old-age-security.html", type: "_blank" },
        { listTitle: "Canada Pension Plan (CPP)", path: "https://www.canada.ca/en/services/benefits/publicpensions/cpp.html", type: "_blank" },
      ],
    },
    {
      id: 4,
      title: "Contact",
      list: [
        {
          listTitle0: APP_CONFIG.address2line,
          icon: <FaLocationDot />,
          path: APP_CONFIG.addressLink,
          type: "_blank",
        },
        {
          listTitle: APP_CONFIG.email,
          icon: <IoMail />,
          path: APP_CONFIG.emailLink,
        },
        {
          listTitle1: APP_CONFIG.phone,
          icon: <FaPhoneAlt />,
          path: APP_CONFIG.phoneLink,
        },
      ],
    },
  ];

  return (
    <>
      <style>{`
        .footer_link_row {
          transition: color 0.18s ease, padding-left 0.18s ease;
        }
        .footer_link_row:hover {
          color: #2E6FF2 !important;
          padding-left: 4px;
        }
        .footer_icon {
          transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;
        }
        .footer_icon:hover {
          background: #2E6FF2;
          color: #1F2A44;
          transform: translateY(-2px);
        }
      `}</style>

      <div
        className="py-5"
        style={{
          background: "#35373a",
          color: "#C7C8CA",
        }}
         >
        <div className="container">
          <div
            className="row m-0 pt-5 justify-content-between"
            style={{ borderTop: "1px solid rgba(46, 111, 242, 0.2)" }}
          >
            <div className="col-12 col-md-6 col-lg-4 pt-3 pe-lg-5">
              <p className="pb-4 mb-0" style={{ color: "#B5B6B8", lineHeight: 1.7 }}>
                Expert tax consultants offering personalized strategies for
                individuals and businesses, ensuring compliance and maximizing
                financial efficiency.
              </p>
              <div className="d-flex footer_icon_container " style={{ gap: "0.6rem" }}>
                {commenIcon.map((icon) => (
                  <Link
                    key={icon.id}
                    className="footer_icon"
                    to={icon.path}
                    target="_blank"
                    style={{
                      width: "38px",
                      height: "38px",
                      borderRadius: "50%",
                      border: "1px solid rgba(46, 111, 242, 0.35)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#2E6FF2",
                    }}
                  >
                    {icon.icon}
                  </Link>
                ))}
              </div>
            </div>
            {footerMenu.map((menuItem, index) => (
              <div
                className="col-12 col-md-6 col-lg-2 pt-3 footerMenu_Container"
                key={menuItem.id}
              >
                <h4
                  className="pb-3 text-nowrap"
                  style={{
                    color: "#F5F5F5",
                    fontWeight: 700,
                    fontSize: "0.95rem",
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                  }}
                >
                  {menuItem.title}
                </h4>
                {menuItem.list.map((footerList, idx) => (
                  <Link to={footerList.path} key={idx} target={footerList.type || '' } style={{ textDecoration: 'none' }}>
                    <div
                      className="d-flex align-items-start m-0 footer_link_row w-100"
                      style={{ color: "#C7C8CA", paddingBottom: "0.85rem" }}
                    >
                      {footerList.icon && (
                        <div className="pe-3" style={{ color: "#2E6FF2", marginTop: "2px", fontSize: "1.1rem" }}>
                          {footerList.icon}
                        </div>
                      )}
                      <div className="d-flex flex-column">
                        {footerList.listTitle0 && <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.5" }}>{footerList.listTitle0}</span>}
                        {footerList.listTitle && <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.5" }}>{footerList.listTitle}</span>}
                        {footerList.listTitle1 && <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.5" }}>{footerList.listTitle1}</span>}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      <CopyRights />
    </>
  );
};

export default Footer;